import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableFmVendor } from "./autogen/AutogenLayoutUserTableFmVendor";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableFmVendor extends AutogenLayoutUserTableFmVendor implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.FM_VENDOR;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
